import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import Header from '../Header';
import Footer from '../Footer';
import { Button } from '../ui/button';
import { useT } from '../../services/i18n';

export const CheckoutProgress = ({ step }) => {
  const { t } = useT();
  const steps = [{ num: 1, label: t('checkout.stepShipping') }, { num: 2, label: t('checkout.stepPayment') }, { num: 3, label: t('checkout.stepConfirmation') }];
  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((s, idx) => (
        <React.Fragment key={s.num}>
          <div className={`flex items-center gap-2 ${step >= s.num ? 'text-orange-500' : 'text-gray-400'}`}>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${step >= s.num ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'}`}>
              {step > s.num ? <CheckCircle size={16} /> : s.num}
            </div>
            <span className="hidden sm:inline font-medium">{s.label}</span>
          </div>
          {idx < 2 && <div className={`w-12 sm:w-24 h-1 mx-2 ${step > s.num ? 'bg-orange-500' : 'bg-gray-200'}`} />}
        </React.Fragment>
      ))}
    </div>
  );
};

const CheckoutConfirmation = ({ assist, shippingInfo, total, orderNumber, orderId }) => {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-12">
        <div data-testid="order-confirmation" className="bg-white rounded-xl shadow-lg p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{assist ? 'Commande créée — lien de paiement envoyé' : t('checkout.confirmed')}</h1>
          <p className="text-gray-600 mb-6" data-testid={assist ? 'phone-order-sent' : undefined}>
            {assist ? `Le client ${shippingInfo.email} a reçu un e-mail avec un lien sécurisé pour régler ${total.toFixed(2)} €. La commande apparaît « En attente de paiement » jusqu'au règlement.` : t('checkout.thanks', { email: shippingInfo.email })}
          </p>
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-500">{t('checkout.orderNumber')}</p>
            <p data-testid="order-confirmation-number" className="text-lg font-mono font-bold text-gray-900">{orderNumber || orderId?.slice(0, 8).toUpperCase()}</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left text-sm text-gray-700">
            <p className="text-xs font-medium text-gray-500 mb-1">{t('checkout.deliveryTo')}</p>
            {shippingInfo.firstName} {shippingInfo.lastName}<br />
            {shippingInfo.address}{shippingInfo.addressComplement ? `, ${shippingInfo.addressComplement}` : ''}<br />
            {shippingInfo.postalCode} {shippingInfo.city}, {shippingInfo.country}
          </div>
          <div className="flex gap-4 justify-center">
            <Button data-testid="confirmation-view-orders-button" onClick={() => navigate('/mes-commandes')} className="bg-orange-500 hover:bg-orange-600">{t('checkout.viewOrders')}</Button>
            <Button onClick={() => navigate('/')} variant="outline">{t('common.continueShopping')}</Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CheckoutConfirmation;
